import { satisfies } from "semver";

import useGetCurrentClusterComponentVersions from "./use-get-current-cluster-component-versions";

function useCurrentClusterSupportsTrafficMetrics(): boolean {
  return useGetCurrentClusterComponentVersions("zero-traffic-metrics").some(
    (v) => satisfies(v, ">=0.1.0"),
  );
}
export default useCurrentClusterSupportsTrafficMetrics;
